import FormsPage from "@/pages/Forms";
export default function RiskAssessmentForms() { return <FormsPage tabId="risk_assessment_forms" />; }
